import * as types from '../actions/types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'

import {
    isPrimitive,
    cotizacion,
    documento,
    compraDirectaItem,
    getPorcentaje,
    solicitudservicioitem,
    solicitudservicioitemcenco
} from '../utils/helpers'
import moment from 'moment';


const INITIAL_STATE = Immutable.fromJS({
    id: null,
    estado: 0,
    solicitud: {},
    unchaged: {},
    aprobadores: [],
    btnSaveDisabled: true,
    btnRComprasDisabled: true,
    btnAproveDisabled: false,
    modified: [],
    modalCreateDocumento: {
		title: '',
		mode: '',
		show: false,
		data: null,
		btnDisabled: false,
        plantillas: [],
        garantias: [],
        unchanged: null,
        contratoanual: false,
        contratosAnuales: []
    },
    modalCreateCompraDirecta: {
        title: '',
        show: false,
        data: null,
        unchaged: null,
        servicio_id: 0,
        cot_id: 0,
        servicio_descripcion: '',
        servicio_cantidad: 0,
    },
    modalAddServicio: {
        show: false,
        title: '',
        mode: null,
        data: null,
        btnDisabled: false
    },

    addModificacion: false,

    remove: [],

    comentario: {
        id: null,
        texto: null,
        btnSendDisabled: false
    }


})

export default function (state = INITIAL_STATE, action) {

    let data, index, servicio, indexServicioCompraDirecta

	switch (action.type) {

        case types.ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO:
            state = state.set('modified', state.get('modified').filter(x => x.get('entity') + x.get('attribute') + x.get('id') !== action.payload.entity + action.payload.attribute + action.payload.id))
            state = state.update('modified', list => list.push(Immutable.fromJS(action.payload)))
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)
            return state

		case types.OBTENER_SOLICITUD_SERVICIO:
			state = state.set('id', action.payload.solicitud.id)
			state = state.set('estado', action.payload.solicitud.estado)
            state = state.set('aprobadores', Immutable.fromJS(action.payload.aprobadores))
            state = state.set('solicitud', Immutable.fromJS(action.payload.solicitud))
            state = state.set('unchaged', Immutable.fromJS(action.payload.solicitud))
            state = state.set('modified', INITIAL_STATE.get('modified'))
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)
            return state

        case types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO1:

            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }

            if (action.payload.path == 'solicitud.servicios.0.fecha_cotizaciones') {
                for (let i = 0; i < state.getIn(['solicitud', 'servicios']).count(); i++) {
                    state = state.setIn(['solicitud', 'servicios', i, 'fecha_cotizaciones'], action.payload.value)
                }
            }


            if (action.payload.path.split('.').slice(-1)[0] == 'responsable_compras' || action.payload.path.split('.').slice(-1)[0] == 'solicitante') {
                state = state.set('btnRComprasDisabled', false)
            }

            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_administracion') {

                const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion'])
                const valor = getPorcentaje(cotizado, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_administracion_value'], valor)
            }



            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_imprevistos') {

                const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos'])
                const valor = getPorcentaje(cotizado, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'], valor)
            }


            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_utilidad') {

                const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad'])
                const valor = getPorcentaje(cotizado, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'], valor)

            }



            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_iva_utilidad' || action.payload.path.split('.').slice(-1)[0] == 'aiu_utilidad') {

                const utilidad = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'])
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad'])
                const valor = getPorcentaje(utilidad, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value'], valor)

            }

            if (action.payload.path.split('.').slice(-1)[0] == 'iva' && action.payload.path.split('.').indexOf("modalCreateDocumento") >= 0) {

                //const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])

                const cotizado = state.getIn(['modalCreateDocumento', 'data', 'detalles']).reduce((acum, detalle) => {
                    acum += detalle.get('valor') * detalle.get('cantidad')
                    return acum
                }, 0)


                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'iva'])
                const valor = getPorcentaje(cotizado, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'iva_value'], valor)

            }

            if (state.getIn(['modalCreateDocumento', 'data'])) {

                // const aiu_administracion_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion_value'])
                // const aiu_imprevistos_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'])
                // const aiu_utilidad_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'])
                // const aiu_iva_utilidad_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value'])

                const iva = state.getIn(['modalCreateDocumento', 'data', 'iva_value'])

                //const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
                const cotizado = state.getIn(['modalCreateDocumento', 'data', 'detalles']).reduce((acum, detalle) => {
                    acum += detalle.get('valor') * detalle.get('cantidad')
                    return acum
                }, 0)

                //const aiu_total = aiu_administracion_value + aiu_imprevistos_value + aiu_utilidad_value + aiu_iva_utilidad_value + iva + cotizado
                const aiu_total = iva + cotizado


                // state = state.setIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado_iva'], cotizado + aiu_total)
                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_total'], aiu_total)


                if (action.payload.path.split('.').slice(-1)[0] == 'tipo') {
                    state = state.setIn(['modalCreateDocumento', 'data', 'plantilla_id'], 0)
                }


                if (action.payload.path.split('.').slice(-1)[0] == 'contratoanual') {
                    state = state.setIn(['modalCreateDocumento', 'data', 'documento_id'], null)
                    state = state.setIn(['modalCreateDocumento', 'data', 'tipo'], 0)
                    state = state.setIn(['modalCreateDocumento', 'data', 'plantilla_id'], -1)
                    state = state.setIn(['modalCreateDocumento', 'data', 'consecutivo'], '')
                }
            }


            if (action.payload.path == 'modalCreateCompraDirecta.data.proveedor') {
                state = state.setIn(['modalCreateCompraDirecta', 'data', 'razon_social'], '')
            }

            if (action.payload.path == 'modalCreateCompraDirecta.data.razon_social') {
                state = state.setIn(['modalCreateCompraDirecta', 'data', 'proveedor'], null)
            }


            return state


        case types.ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO:

            const nuevaCotizacion = cotizacion()
            nuevaCotizacion.fecha_entrega = moment(state.getIn(['solicitud', 'fecha_requerido'])).format('YYYY-MM-DD')
            nuevaCotizacion.servicio = state.getIn(['solicitud', 'servicios', action.payload.indexServicio])
			state = state.updateIn(`${action.payload.path}`.split('.'), list => list.push(Immutable.fromJS(nuevaCotizacion)))

            return state


        case types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO:
            state = state.setIn(action.payload.path.split('.'),  Immutable.fromJS(action.payload.value))
            if (action.payload.path.split('.').slice(-1)[0] == 'proveedore') {
                const path = action.payload.path.split('.')
                state = state.setIn([...path.slice(0,path.length-1), 'proveedor_id'], action.payload.value.id)
            }
            return state


        case types.ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO:
			state = state.updateIn(`${action.payload.path}`.split('.'), list => list.filter(x => !x.get('selected')))
            return state


        case types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO:
			state = state.set('btnSaveDisabled', action.payload)
            return state


        case types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO:
            state = state.set('btnAproveDisabled', action.payload)
            return state


        case types.ACTUALIZAR_SOLICITUD_SERVICIO:
            const solicitudActualizada = action.payload.solicitud
            for (let index = 0; index < solicitudActualizada.servicios.length; index++) {
                solicitudActualizada.servicios[index].cotizaciones_aprobar = solicitudActualizada.servicios[index].cotizaciones.filter(ele => ele.estado === 4)
            }

            const ops = diff(state.get('solicitud'), Immutable.fromJS(solicitudActualizada))
            state = state.set('solicitud', patch(state.get('solicitud'), ops))

            if (ops.filter(x => x.get('path') === '/estado').count() === 1) {
                state = state.set('estado', state.getIn(['solicitud', 'estado']))
            }
            for (let i = 0; i < action.payload.aprobadores.length; i++) {
              for (let j = 0; j < action.payload.aprobadores[i].aprobaciones.length; j++) {
                    action.payload.aprobadores[i].aprobaciones[j].selected = action.payload.aprobadores[i].aprobaciones[j].estado === 2
                }
            }
            state = state.set('aprobadores', Immutable.fromJS(action.payload.aprobadores))

            state = state.set('btnRComprasDisabled', true)

            state = state.set('btnSaveDisabled', true)

            state = state.set('unchaged', state.get('solicitud'));

            state = state.set('addModificacion', false)

            state = state.set('comentario', INITIAL_STATE.get('comentario'));

            return state

        case types.CONMUTAR_RECOMENDACION_COTIZACION_SERVICIO:

            const indexServicio = action.payload.indexServicio
            const indexCotizacion = action.payload.indexCotizacion

            for (let i = 0; i < state.getIn(['solicitud', 'servicios', indexServicio, 'cotizaciones_aprobar']).count(); i++) {
                state = state.setIn(['solicitud', 'servicios', indexServicio, 'cotizaciones_aprobar', i, 'recomendado'], false)
            }
            state = state.setIn(['solicitud', 'servicios', indexServicio, 'cotizaciones_aprobar', indexCotizacion, 'recomendado'], true)

            return state




        case types.CONMUTAR_SELECCION_APROBACION_SERVICIO:

            const servicioid = action.payload.servicioid
            const aprobadorid = action.payload.aprobadorid
            const aprobacionid = action.payload.aprobacionid

            const indexAprobador = state.get('aprobadores').findIndex(x => x.get('id') == aprobadorid)
            const indexAprobacion = state.getIn(['aprobadores', indexAprobador, 'aprobaciones']).findIndex(x => x.get('id') == aprobacionid)
            const aprobaciones = state.getIn(['aprobadores', indexAprobador, 'aprobaciones']).filter(x => x.getIn(['cotizacione', 'servicios', 0, 'id']) == servicioid)

            for (let i = 0; i < aprobaciones.count(); i++) {
                const index = state.getIn(['aprobadores', indexAprobador, 'aprobaciones']).findIndex(x => x.get('id') == aprobaciones.getIn([i,'id']))
                state = state.setIn(['aprobadores', indexAprobador, 'aprobaciones', index, 'estado'], 1)
            }

            state = state.setIn(['aprobadores', indexAprobador, 'aprobaciones', indexAprobacion, 'estado'], 3) // 3 es Seleccionado pero no aprobado

            return state


        case types.MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO:

            state = state.setIn(['modalCreateDocumento', 'show'], action.payload.show)

            if (action.payload.show) {

                state = state.setIn(['modalCreateDocumento', 'title'], action.payload.title)
                state = state.setIn(['modalCreateDocumento', 'mode'], action.payload.mode)
                state = state.setIn(['modalCreateDocumento', 'plantillas'], Immutable.fromJS(action.payload.plantillas))
                state = state.setIn(['modalCreateDocumento', 'garantias'], Immutable.fromJS(action.payload.garantias))
                state = state.setIn(['modalCreateDocumento', 'contratosAnuales'], Immutable.fromJS(action.payload.contratos))


                if (action.payload.mode === 'create') {

                    const solicitud_id = state.get('id')
                    const documento_id = state.getIn(['solicitud', 'documentos', action.payload.indexDocumento, 'id'])
                    const proveedor_id = state.getIn(['solicitud', 'documentos', action.payload.indexDocumento, 'proveedor', 'id'])
                    state = state.setIn(['modalCreateDocumento', 'data'], Immutable.fromJS(documento(documento_id, solicitud_id, proveedor_id)))

                } else if (action.payload.mode === 'edit') {

                    state = state.setIn(['modalCreateDocumento', 'data'], state.getIn(['solicitud', 'documentos', action.payload.indexDocumento]))
                    state = state.setIn(['modalCreateDocumento', 'unchanged'], state.getIn(['solicitud', 'documentos', action.payload.indexDocumento]))
                    const tipo = state.getIn(['modalCreateDocumento', 'data', 'tipo'])

                    const creado = state.getIn(['modalCreateDocumento', 'data', 'consecutivo']) ? true : false;
                    if (!creado) {
                        state = state.setIn(['modalCreateDocumento', 'data', 'entregas_parciales'], true)
                    }

                    if (!state.getIn(['modalCreateDocumento', 'data', 'fecha_inicio']))
                        state = state.setIn(['modalCreateDocumento', 'data', 'fecha_inicio'], state.getIn(['solicitud', 'fecha_inicio']) || moment().format('YYYY-MM-DD'))
                    if (!state.getIn(['modalCreateDocumento', 'data', 'fecha_entrega']))
                        state = state.setIn(['modalCreateDocumento', 'data', 'fecha_entrega'], state.getIn(['solicitud', 'fecha_requerido'] || moment().format('YYYY-MM-DD')))


                    if (tipo == 5) {
                        state = state.setIn(['modalCreateDocumento', 'contratoanual'], true)
                    }


                    if (tipo == 4) {
                        state = state.setIn(['modalCreateDocumento', 'data', 'anticipo'], 0)
                    }


                    const cotizado = state.getIn(['modalCreateDocumento', 'data', 'detalles']).reduce((acum, detalle) => {
                        acum += detalle.get('valor') * detalle.get('cantidad')
                        return acum
                    }, 0)


                    const iva = state.getIn(['modalCreateDocumento', 'data', 'iva'])
                    state = state.setIn(['modalCreateDocumento', 'data', 'iva_value'], getPorcentaje(cotizado, iva) || 0)



                    const aiu_total = state.getIn(['modalCreateDocumento', 'data', 'iva_value']) + cotizado

                    state = state.setIn(['modalCreateDocumento', 'data', 'aiu_total'], aiu_total)

                }

            } else {
                state = state.set('modalCreateDocumento', INITIAL_STATE.get('modalCreateDocumento'))
            }

            return state


        case types.MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_SOLICITUD_SERVICIO:
            state = state.setIn(['modalCreateCompraDirecta', 'show'], action.payload.show)

            if (action.payload.show) {
                state = state.setIn(['modalCreateCompraDirecta', 'title'], action.payload.title)
                indexServicioCompraDirecta = state.getIn(['solicitud', 'servicios']).findIndex(servicio => servicio.get('id') === action.payload.servicio_id)
                servicio = state.getIn(['solicitud', 'servicios', indexServicioCompraDirecta])
                const FacturaCompraDirectaServicios = servicio.get('factura_compra_directa_servicios')
                state = state.setIn(['modalCreateCompraDirecta', 'servicio_id'], Immutable.fromJS(action.payload.servicio_id))
                state = state.setIn(['modalCreateCompraDirecta', 'cot_id'], Immutable.fromJS(action.payload.cotizacion.get('id')))
                state = state.setIn(['modalCreateCompraDirecta', 'servicio_descripcion'], servicio.getIn(['item', 'descripcion']))
                state = state.setIn(['modalCreateCompraDirecta', 'servicio_cantidad'], servicio.get('cantidad'))

                state = state.setIn(['modalCreateCompraDirecta', 'data'], Immutable.fromJS(FacturaCompraDirectaServicios || compraDirectaItem()))
                state = state.setIn(['modalCreateCompraDirecta', 'data', 'razon_social'], action.payload.cotizacion.get('razon_social'))
                state = state.setIn(['modalCreateCompraDirecta', 'unchanged'], Immutable.fromJS(FacturaCompraDirectaServicios || {}))
            }

            return state

        case types.ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO:
            const garantia = state.getIn(['modalCreateDocumento', 'garantias', String(action.payload)])
            state = state.updateIn(['modalCreateDocumento', 'data', 'garantias'], list => list.push(garantia))
            return state

        case types.REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO:
            state = state.setIn(['modalCreateDocumento', 'data', 'garantias'], state.getIn(['modalCreateDocumento', 'data', 'garantias']).filter(x => x.get('id') != action.payload))
            return state

        case types.DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO:
            state = state.setIn(['modalCreateDocumento', 'btnDisabled'], action.payload)
            return state



        case types.ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO1:
            state = state.updateIn(['solicitud', 'adjuntos'], list => list.filter(x => !x.get('selected')))
            return state

        case types.ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO:
            const cot = cotizacion()
            cot.estado = 3
            state = state.updateIn(`${action.payload.path}`.split('.'), list => list.push(Immutable.fromJS(cot)))
            return state

        case types.SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO:
            let cotizacion_actual = state.getIn(['solicitud', 'servicios', action.payload.indexServicio, 'cotizaciones'])
                                        .filter(cotizacion => cotizacion.get('id') == action.payload.cotizacion_id)
            if (cotizacion_actual.count() > 0) {
                state = state.setIn(['solicitud', 'servicios', action.payload.indexServicio, 'cotizaciones_aprobar', action.payload.indexCotizacionAprobar  ], cotizacion_actual.get(0))
                state = state.setIn(['unchaged', 'servicios', action.payload.indexServicio, 'cotizaciones_aprobar', action.payload.indexCotizacionAprobar   ], cotizacion_actual.get(0))
                let validacionProveedor = cotizacion_actual.get(0).toJS().proveedore === null ? false : true
                // if(validacionProveedor == false){

                // }
            }

            return state

        case types.MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1:
            state = state.setIn(['modalAddServicio', 'title'], action.payload.title)
            state = state.setIn(['modalAddServicio', 'show'], action.payload.show)
            state = state.setIn(['modalAddServicio', 'mode'], action.payload.mode)
            data = Immutable.fromJS(solicitudservicioitem())
			if (action.payload.mode === 'edit') {
                data = state.getIn(['solicitud', 'servicios', String(action.payload.index)])
			}
            state = state.setIn(['modalAddServicio', 'data'], data)
            return state

        case types.OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1:
            state = state.set('modalAddServicio', INITIAL_STATE.get('modalAddServicio'))
            return state


        case types.ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO1:


            data = state.getIn(['modalAddServicio', 'data'])

            const mode = state.getIn(['modalAddServicio', 'mode'])


            if (mode == 'create') {
                state = state.setIn(['solicitud', 'servicios'], state.getIn(['solicitud', 'servicios']).push(data))
            }

            if (mode == 'edit') {
                index = state.getIn(['solicitud', 'servicios']).findIndex(x => ((data.get('guid') && x.get('guid') === data.get('guid')) || x.get('id') === data.get('id')))
                if (index >= 0) {
                    state = state.setIn(['solicitud', 'servicios', String(index)], data)
                }
            }

            state = state.set('addModificacion', true)

            return state


        case types.ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO1:
            let actual = state.getIn(['modalAddServicio', 'data', 'cencos']).reduce((a ,b) => { a += Number(b.getIn(['pivot', 'porcentaje'])); return a }, 0)
			state = state.updateIn(['modalAddServicio', 'data', 'cencos'], list => list.push(Immutable.fromJS({pivot:solicitudservicioitemcenco(actual)})))
            return state

        case types.ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM1:
			state = state.updateIn(['modalAddServicio', 'data', 'cencos'], list => list.filter(x => !x.get('selected')))
            return state

        case types.ELIMINAR_ITEMS_SOLICITUD_SERVICIO:
            state = state.updateIn(['solicitud', 'servicios'], list => list.filter(item => !item.get('selected')))
            state = state.set('remove', action.payload.remove)
            state = state.set('addModificacion', true)
            return state


        case types.EDITAR_COMENTARIO_SOLICITUD_SERVICIO1:
            index = state.getIn(['solicitud','foros']).findIndex(c => c.get('id') === action.payload.id)
            state = state.setIn(['comentario','id'], action.payload.id)
            state = state.setIn(['comentario','texto'], state.getIn(['solicitud', 'foros', index, 'comentario']))
            return state

        case types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_SERVICIO1:
            state = state.setIn(['comentario','btnSendDisabled'], action.payload)
            return state

        case types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_SERVICIO1:
            state = state.setIn(['solicitud','foros'], Immutable.fromJS(action.payload.foros))
            state = state.set('comentario', INITIAL_STATE.get('comentario'));
            return state

       	default:
            return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/solicitudservicio.js